import { useQuery } from 'react-query';
import CompanyService from '@/app/services/CompanyService';
import { useUserContext } from '@/app/contexts/UserContext';

/**
 * Hook to fetch a single company setting for the active branch
 * @param {string} setting - The setting key to fetch
 * @param {Object} options - Configuration options
 * @param {*} options.defaultValue - Default value if setting not found
 * @param {boolean} options.convertToBoolean - Whether to convert result to boolean
 * @returns {Object} Query result with data and loading state
 */
const useCompanySetting = (setting, { defaultValue = false, convertToBoolean = false } = {}) => {
    const user = useUserContext();

    return useQuery({
        queryKey: ['company', user.active_company.ID, 'branch', user.active_branch.ID, 'settings', setting],
        cacheTime: 1000 * 60 * 5, // 5 minutes
        queryFn: () => {
            return CompanyService.getBranchSettings(setting, defaultValue, convertToBoolean, user.active_branch.ID);
        },
    });
};

export default useCompanySetting;
